import type { StopKind } from "../../../utils/metro-stops";

export type MetroStopIconProps = {
    kind: StopKind | 'trophy';
    bonus?: boolean;
    size: number;
};

const STROKE = { fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

/** The glyph inside a stop; it carries the state for those who do not tell the colours apart. */
export function MetroStopIcon({ kind, bonus, size }: MetroStopIconProps) {
    return (
        <svg width={ size } height={ size } viewBox="0 0 24 24" aria-hidden="true">
            { glyph(kind, bonus) }
        </svg>
    );
}

function glyph(kind: StopKind | 'trophy', bonus?: boolean) {
    switch (kind) {
        case 'done':
            return <path d="M5 12l5 5 9-10" { ...STROKE } strokeWidth="3.6"/>;
        case 'recap':
        case 'waiting':
            return <g { ...STROKE } strokeWidth="3"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 3v5h5"/></g>;
        case 'current':
            return <path d="M8 4l12 8-12 8z" fill="currentColor"/>;
        case 'open':
            return bonus
                ? <path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9z" fill="currentColor"/>
                : <circle cx="12" cy="12" r="6" fill="currentColor"/>;
        case 'locked':
            return <g { ...STROKE } strokeWidth="2.8"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></g>;
        case 'off':
            return <path d="M6 18L18 6" { ...STROKE } strokeWidth="3"/>;
        case 'trophy':
            return (
                <g { ...STROKE } strokeWidth="2.6">
                    <path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v5a5 5 0 0 1-10 0z"/>
                    <path d="M7 6H4a3 3 0 0 0 3 4"/><path d="M17 6h3a3 3 0 0 1-3 4"/>
                </g>
            );
    }
}
